export default __webpack_public_path__ + "static/dublin-401ae0dc9cd5659057e879b362b9a720.png";